import Vue from 'vue';
import enMap from './en.json';
import zhChMap from './zh-cn.json';
import { getCookieObj } from '@/util/base';

const allLangMap = {
  en: enMap,
  'zh-CN': zhChMap,
  default: enMap,
};
const cookieObj = getCookieObj();

const lang = cookieObj.lang || 'zh-CN';

Vue.prototype.$t = window.$t = (key, params) => {
  const currentLangMap = allLangMap[lang] || allLangMap.default;
  let value = currentLangMap[key] || key;
  if (params) {
    Object.keys(params).forEach(key => {
      value = value.replace(`{{${key}}}`, params[key]);
    });
  }
  return value;
};
